import React from 'react'
import './GalleryPage.scss'
import GalleryAutoGrid from './GalleryAutoGrid'

const GalleryPage = () => {
  return (
    <main className='GalleryPage'>
      <GalleryAutoGrid/>
    </main>
  )
}

export default GalleryPage